
<ng-container *ngIf="!subValue; else withSubValue;">
	<span [ngClass]="[
			styles.value,
			deltaCssClass
		]" [countUp]="value" [options]="{
			decimal: localeDecimalSymbol,
			decimalPlaces: decimalPlaces,
			duration: .4,
			separator: localeGroupSymbol,
			suffix: suffix
		}" [reanimateOnClick]="false">
	</span>

	<span class="glyphicons" [ngClass]="[
			styles.icon,
			deltaIconCssClass,
			thresholdIconCssClass
		]">
	</span>
</ng-container>

<ng-template #withSubValue>
	<div layout="row">
		<div flex="fill" [ngClass]="styles.item">
			<div>
				{{ valueLabel }}
			</div>
			<div class="padding-top-5" [ngClass]="[
					styles.itemValue,
					deltaCssClass
				]" [countUp]="value" [options]="{
					decimal: localeDecimalSymbol,
					decimalPlaces: decimalPlaces,
					duration: .4,
					separator: localeGroupSymbol,
					suffix: suffix
				}" [reanimateOnClick]="false">
			</div>
			<span class="glyphicons" [ngClass]="[
					styles.itemIndicator,
					deltaIconCssClass,
					thresholdIconCssClass
				]">
			</span>
		</div>
		<div flex="fill" [ngClass]="styles.item">
			<div>
				{{ subValueLabel }}
			</div>
			<div class="padding-top-5" [ngClass]="[
					styles.itemValue,
					subValueDeltaCssClass
				]" [countUp]="subValue" [options]="{
					decimal: localeDecimalSymbol,
					decimalPlaces: decimalPlaces,
					duration: .4,
					separator: localeGroupSymbol,
					suffix: suffix
				}" [reanimateOnClick]="false">
			</div>
			<span class="glyphicons" [ngClass]="[
					styles.itemIndicator,
					subValueDeltaIconCssClass,
					subValueThresholdIconCssClass
				]">
			</span>
		</div>
	</div>
</ng-template>